// extracted by mini-css-extract-plugin
module.exports =  {"layout":"hZ3_OhS"};